import * as Sentry from '@sentry/browser'

export default function setWidgets (shopObj, plan) {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  try {
    Sentry.configureScope(scope => {
      scope.setUser({
        id: shopObj.myshopify_domain,
        email: shopObj.email,
        username: shopObj.myshopify_domain,
        shop: `https://${shopObj.domain}`,
        location: `${shopObj.city}, ${shopObj.country}`,
        phone: shopObj.phone,
        plan
      })
    })
  } catch (e) {}

  try {
    if (document.cookie.includes('kraken=1')) {
      window.FS.shutdown()
    } else {
      window.FS.identify(shopObj.myshopify_domain, {
        displayName: shopObj.shop_owner,
        email: shopObj.email,
        company: shopObj.name,
        shop: `https://${shopObj.domain}`,
        location: `${shopObj.city}, ${shopObj.country}`,
        phone: shopObj.phone,
        release: process.env.VUE_APP_COMMIT_REF,
        plan
      })
    }
  } catch (e) {}

  try {
    window.fcWidget.setExternalId(shopObj.myshopify_domain)
    window.fcWidget.user.setFirstName(shopObj.shop_owner)
    window.fcWidget.user.setEmail(shopObj.email)
    window.fcWidget.user.setProperties({
      company: shopObj.name,
      username: shopObj.myshopify_domain,
      shop: `https://${shopObj.domain}`,
      location: `${shopObj.city}, ${shopObj.country}`,
      phone: shopObj.phone,
      release: process.env.VUE_APP_COMMIT_REF,
      plan
    })
  } catch (e) {}
}
